// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1ffh0fe0 {
  padding-right: 0;
  padding-left: 0;
}
._1ffh0fe1 {
  border-color: none;
}
._1ffh0fe2 {
  border-color: var(--_18w76bw28);
  background-color: var(--_18w76bw25);
}
._1ffh0fe3 {
  border-radius: var(--_18w76bw4q);
  width: var(--_18w76bwj);
  height: var(--_18w76bwj);
}
._1ffh0fe4 {
  width: var(--_18w76bwm);
  height: var(--_18w76bwm);
}
._1ffh0fe6:last-child {
  visibility: hidden;
}
._1ffh0fe7 {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
}
._1ffh0fe8 {
  background-color: rgb(235, 247, 251);
  color: var(--_18w76bw22);
}
._1ffh0fe9 {
  background-color: white;
  color: var(--_18w76bw2e);
  border: 2px solid black;
}
._1ffh0fea {
  font-size: var(--_18w76bw3n);
  width: var(--_18w76bwj);
}
._1ffh0feb {
  width: var(--_18w76bww);
}
._1ffh0fec:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
._1ffh0fec:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,+BAA+B;EAC/B,mCAAmC;AACrC;AACA;EACE,gCAAgC;EAChC,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;AACA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B","sourcesContent":["._1ffh0fe0 {\n  padding-right: 0;\n  padding-left: 0;\n}\n._1ffh0fe1 {\n  border-color: none;\n}\n._1ffh0fe2 {\n  border-color: var(--_18w76bw28);\n  background-color: var(--_18w76bw25);\n}\n._1ffh0fe3 {\n  border-radius: var(--_18w76bw4q);\n  width: var(--_18w76bwj);\n  height: var(--_18w76bwj);\n}\n._1ffh0fe4 {\n  width: var(--_18w76bwm);\n  height: var(--_18w76bwm);\n}\n._1ffh0fe6:last-child {\n  visibility: hidden;\n}\n._1ffh0fe7 {\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  line-height: 1;\n}\n._1ffh0fe8 {\n  background-color: rgb(235, 247, 251);\n  color: var(--_18w76bw22);\n}\n._1ffh0fe9 {\n  background-color: white;\n  color: var(--_18w76bw2e);\n  border: 2px solid black;\n}\n._1ffh0fea {\n  font-size: var(--_18w76bw3n);\n  width: var(--_18w76bwj);\n}\n._1ffh0feb {\n  width: var(--_18w76bww);\n}\n._1ffh0fec:first-child {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n._1ffh0fec:last-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
